// SimCardDropdown.jsx
import React, { useState, useEffect } from 'react';
import {
  TextField,
  Autocomplete,
  CircularProgress,
  FormControl,
  Box
} from '@mui/material';
import AxiosMain from "../../components/layout/AxiosMain";
import { AppAPiUrl } from "../../configs/appData";

const SimCardDropdown = ({ value, onChange, label }) => {
  const [options, setOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const fetchSimCards = (search, pageNumber) => {
    setLoading(true);
    AxiosMain.get(AppAPiUrl.MobileSim, {
      params: {
        available: true,
        search,
        page: pageNumber,
        page_size: 10,
      }
    })
      .then((res) => {
        const newOptions = res.data.results;
        setOptions(prev =>
          pageNumber === 1 ? newOptions : [...prev, ...newOptions]
        );
        setHasMore(res.data.next !== null);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching SIM cards:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    setPage(1);
    fetchSimCards(inputValue, 1);
  }, [inputValue]);

  const handleListboxScroll = (event) => {
    const listboxNode = event.currentTarget;
    if (
      listboxNode.scrollTop + listboxNode.clientHeight >=
        listboxNode.scrollHeight - 1 &&
      !loading &&
      hasMore
    ) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchSimCards(inputValue, nextPage);
    }
  };

  // Convert Formik's "value" (ID) to actual SIM object
  const selectedOption = options.find(opt => opt.id === value) || null;

  return (
    // Wrap in same Box / FormControl classes you use in PaginationDropDown
    <Box className="cm-form-drop-down">
      <div className="form-lable-name">
        {label}
      </div>
      <FormControl fullWidth variant="outlined">
        <Autocomplete
          // Like a standard MUI Autocomplete, but inside your FormControl
          value={selectedOption}
          onChange={(event, newOption) => {
            // Return only the 'id' to form
            onChange(newOption ? newOption.id : '');
          }}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
          options={options}
          getOptionLabel={(option) => option.icc || ''}
          isOptionEqualToValue={(option, val) => option.id === val?.id}
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          ListboxProps={{
            onScroll: handleListboxScroll,
          }}
        />
      </FormControl>
    </Box>
  );
};

export default SimCardDropdown;
